exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner-gift-container{max-width:1236px;height:340px}@media screen and (max-width:1236px){.banner-gift-container{padding:0 1rem}}@media screen and (max-width:768px){.banner-gift-container{height:auto}}", ""]);

// exports
